<!--
/**
* @name: YAnchor.vue
* @description: 锚点
* @author: 于海威
* @create: 2020/08/13 17:06:03
* @update: 2020/08/13 17:06:03
*/
-->

<script>
export default {
  props: {
    anchor: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      anchorIndex: 0,
    };
  },
  methods: {
    onGo2Anchor(id, index) {
      const el = this.$parent.$el;
      const targetEl = el.querySelector(`#${id}`);
      if (targetEl) {
        // console.log(targetEl.offsetTop);
        let top = targetEl.offsetTop;
        top -= 60; // 顶部有固定导航高度
        window.scrollTo({ behavior: "smooth", top });
        this.anchorIndex = index;
      } else {
        console.warn("请录入锚定位置元素id");
      }
    },
  },
  render() {
    const anchorList = this.anchor.map((a, i) => (
      <a
        href="javascript:void(0);"
        onClick={() => {
          this.onGo2Anchor(a.id, i);
        }}
        class={[this.css.anchor_item, this.anchorIndex == i ? this.css.anchor_active : ""]}
      >
        {a.text}
      </a>
    ));
    return <div class={this.css.anchor_box}>{anchorList}</div>;
  },
};
</script>

<style lang="postcss" module="css">
.anchor_box {
  display: flex;
  position: fixed;
  top: 88px;
  right: 40px;
  z-index: 1001;
  width: 95px;
  flex-direction: column;
  & .anchor_item {
    display: block;
    width: 100%;
    line-height: 32px;
    text-align: center;
    color: #188fff;
    font-weight: bold;
    margin: 8px 0;
    border-radius: 16px;
    background: #fff;
    transition: all 0.3s linear;
  }
  & .anchor_item.anchor_active {
    background: #178fff;
    color: #fff;
    transition: all 0.3s linear;
  }
}
</style>
